import { Routes } from '@angular/router';
import { HomeComponent } from './sections/home.component';

export const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: '**', redirectTo: '' }
];